import type { ReactNode } from 'react'
import './documentPrint.css'

interface DocumentShellProps {
  title: string
  subtitle?: string
  meta?: Array<{ label: string; value: ReactNode }>
  actions?: ReactNode
  children: ReactNode
}

export default function DocumentShell({ title, subtitle, meta = [], actions, children }: DocumentShellProps) {
  return (
    <div className="min-h-screen bg-slate-100 px-3 py-4 sm:px-4 sm:py-8">
      <div className="document-page mx-auto w-full max-w-5xl border border-slate-300 bg-white text-slate-900 shadow-[0_8px_30px_rgba(15,23,42,0.08)]">
        <div className="border-b border-slate-300 px-4 py-4 sm:px-6 lg:px-8 no-print">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500">Diamond Dispatch</div>
              <h1 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950 sm:text-3xl">{title}</h1>
              {subtitle && <p className="mt-1 text-sm text-slate-600">{subtitle}</p>}
            </div>
            <div className="flex flex-wrap gap-2">
              {actions}
              <button
                type="button"
                onClick={() => window.print()}
                className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
              >
                Print / Save as PDF
              </button>
            </div>
          </div>
          {meta.length > 0 && (
            <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-2 lg:grid-cols-4">
              {meta.map((item) => (
                <div key={item.label} className="rounded border border-slate-200 bg-slate-50 px-3 py-2">
                  <dt className="text-[10px] uppercase tracking-[0.24em] text-slate-500">{item.label}</dt>
                  <dd className="mt-1 font-medium text-slate-900">{item.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>

        <div className="px-4 py-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </div>
    </div>
  )
}
